<style lang="less">
.copy-success-tip {
  padding: 0;
  width: 200px;
  height: 36px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 3px;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 21px;
  top: 285px;
}
.copy-success-tipM {
  padding: 0;
  width: 400px;
  height: 72px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 6px;
  font-size: 28px;
  color: #FFFFFF;
  line-height: 42px;
  // top: 570px;
}
.intermediate,
.intermediateM {
  width: 375px;
  height: auto;
  margin: auto;
  // background: url("/s/k/images/bg_body.png");
  background-color: #f5f5f5;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #696464;
  padding: 0px 0 50px 0;
  font-size: 12px;
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    z-index: 999;
  }
  .page {
    padding-top: 20px;
    .lesson {
      width: 335px;
      margin: auto;
      background-size: 100% 100%;
      text-align: center;
      font-size: 16px;
      position: relative;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.08);
      overflow: hidden;
      .lessonInfo {
        width: 100%;
        background: url("../../assets/images/k/bg_top.png") center top no-repeat;
        background-size: cover;
        text-align: center;
        padding: 42px 0;
        color: #fff;
        position: relative;
        .comma {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 36px;
          height: 36px;
          background: url("../../assets/images/k/qr-img.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          cursor: pointer;
        }
        .lessonName {
          width: 280px;
          margin: auto;
          font-size: 21px;
          font-weight: bolder;
          position: relative;
          z-index: 1;
          word-wrap: break-word;
        }
        .teacherName {
          color: #bfe3d8;
          width: 295px;
          margin-left: auto;
          margin-right: auto;
        }
        .avatarImg {
          position: absolute;
          z-index: 1;
          bottom: -27px;
          left: 50%;
          width: 54px;
          height: 54px;
          border-radius: 6px;
          transform: translateX(-50%);
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .lessonContent {
        font-size: 15px;
        color: #999;
        width: 100%;
        background-color: #fff;
        // background: url("../../assets/images/k/bg_border_cover_body.png");
        // background-size: 100% 100%;
        text-align: center;
        margin: auto;
        padding: 42px 0 30px 0;
        position: relative;
        &.lessonResultContent {
          padding-top: 63px;
        }
        .lessonTime {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 265px;
          margin: 0 auto;
          padding-bottom: 25px;
          border-bottom: #E0E0E0 solid 1px;

          .lesson-hm {
            font-size: 27px;
            font-family: 'PingFangSC-Medium', 'PingFang SC';
            font-weight: 500;
            color: #000000;
            line-height: 38px;
          }
          .lesson-duration {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-family: 'PingFangSC-Regular', 'PingFang SC';
            font-weight: 400;
            color: #999999;
            line-height: 15px;

            &:before {
              content: "";
              display: inline-block;
              width: 15px;
              height: 2px;
              background: url('../../assets/images/k/time-left.png') center center no-repeat;
              background-size: 100% 100%;
              margin-right: 6px;
              margin-top: 3px;
            }
            &:after {
              content: "";
              display: inline-block;
              width: 15px;
              height: 4px;
              background: url('../../assets/images/k/time-right.png') center center no-repeat;
              background-size: 100% 100%;
              margin-left: 6px;
            }
          }
          .lesson-year {
            font-size: 12px;
            font-family: 'PingFangSC-Regular', 'PingFang SC';
            font-weight: 400;
            color: #999999;
            line-height: 17px;
          }
        }

        .copy {
          display: flex;
          align-items: center;
          width: 265px;
          margin: 25px auto 0;
          font-size: 15px;
          font-family: 'PingFangSC-Medium', 'PingFang SC';
          font-weight: 500;
          color: #000000;
          line-height: 21px;
          text-align: left;
          .publessonId {
            font-size: 18px;
          }
          .copy-icon {
            margin-left: 43px;
            display: inline-block;
            width: 15px;
            height: 15px;
            background: url('../../assets/images/k/copy.png') center center no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }
        }

        .apply-nums {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          font-size: 12px;
          color: #999;
          .appply-imgs {
            display: flex;
            align-items: center;
            margin-right: 14px;
            & > li {
              display: inline-block;
              width: 22px;
              height: 22px;
              border-radius: 50%;
              border: 1px solid #fff;
              overflow: hidden;

              &:not(:first-child) {
                margin-left: -4px;
              }

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .download-tip {
          margin-top: 15px;
          font-size: 14px;
          color: #b1b1b1;
          cursor: pointer;
        }
      }
      .jumpPage {
        // padding-top: 5px;
      }
      .lessonResultContent {
        .resultImg {
          width: 96px;
          margin: auto;
          // margin-top:40px;
        }
        .context {
          text-align: center;
          font-size: 20px;
          color: #696464;
          margin-top: 20px;
          margin-bottom: 5px;
          font-weight: bolder;
        }
        .subtitle {
          width: 264px;
          margin: auto;
          color: #696464;
          margin-top: 16px;
        }
        span {
          text-align: center;
          font-size: 15px;
          color: #696464;
        }
      }
      .footerBorder {
        width: 100%;
        height: 40px;
        background: url("../../assets/images/k/bg_border_cover_footer.png");
        background-size: 100% 100%;
        text-align: center;
      }
    }
    .signUpByPhone {
      background-size: 100% 100%;
      text-align: center;
    }
    .introduction {
      text-align: center;
      width: 340px;
      margin: auto;
      margin-top: 23px;
      .title {
        background: url("../../assets/images/k/icon_dot.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        width: 278px;
        height: 19px;
        margin: auto;
        .bgtext {
          position: absolute;
          font-size: 40px;
          color: #eaeaea;
          font-weight: 300;
          left: 50%;
          top: -8px;
          transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
        }
        .titleText {
          position: absolute;
          font-size: 28px;
          text-align: center;
          left: 50%;
          top: -11px;
          transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
          color: #333;
        }
      }
      .whiteBoard {
        width: 100%;
        margin: auto;
        border-radius: 8px;
        padding: 23px 18px;
        background: #fff;
        box-shadow: 0px 15px 15px 0px rgba(0, 0, 0, 0.1);
        margin-top: 40px;
        word-wrap: break-word;
        word-break: break-all;
        img {
          max-width: 100% !important;
        }
        p {
          text-align: left;
          line-height: 1.5;
          img {
            max-width: 100% !important;
            text-align: center;
            display: inline-block;
          }
        }
      }
    }
  }
  .submitBtn {
    display: block;
    width: 270px;
    height: 40px;
    margin: auto;
    line-height: 40px;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    border-radius: 5px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 0;
    outline: none;
    background-color: #009265;
    margin-top: 50px;
    // position: absolute;
    // z-index: 2;
    // left: 50%;
    // transform: translateX(-50%);
    // -webkit-transform: translateX(-50%);
  }
}
.intermediateM {
  position: absolute;
  width: 100vw;
  min-height: 100vh;
  padding: 0px 0 100px 0;
  background-position: 0px -1px;
  box-sizing: border-box;
  font-size: 24px;
  left: 0;
  right: 0;
  top: 0;
  .page {
    padding-top: 40px;
    .lesson {
      width: 670px;
      font-size: 32px;
      box-sizing: border-box;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
      box-shadow: 0px 20px 50px 0px rgba(0, 0, 0, 0.08);
      .lessonInfo {
        padding: 84px 0;
        .comma {
          top: 20px;
          right: 20px;
          width: 72px;
          height: 72px;
        }
        .lessonName {
          width: 590px;
          max-height: 134px;
          font-size: 42px;
        }
        .lessonStartTime {
          margin-top: 16px;
        }
        .teacherName{
          margin: 16px auto 0;
          width: 590px;
        }
        .avatarImg {
          bottom: -54px;
          width: 108px;
          height: 108px;
          border-radius: 12px;
        }
      }
      .lessonContent {
        font-size: 30px;
        padding: 84px 0 60px 0;
        margin-top: -1px;
        &.lessonResultContent {
          padding-top: 125px;
        }

        .lessonTime {
          width: 530px;
          padding-bottom: 50px;

          .lesson-hm {
            font-size: 54px;
            line-height: 75px;
          }
          .lesson-duration {
            font-size: 22px;
            line-height: 30px;
            &:before {
              width: 30px;
              height: 4px;
              margin-right: 13px;
              margin-top: 4px;
            }
            &:after {
              width: 30px;
              height: 8px;
              margin-left: 13px;
            }
          }
          .lesson-year {
            font-size: 24px;
            line-height: 33px;
          }
        }

        .copy {
          width: 530px;
          margin: 50px auto 0;
          font-size: 30px;
          line-height: 42px;
          .publessonId {
            font-size: 36px;
          }
          .copy-icon {
            margin-left: 86px;
            width: 30px;
            height: 30px;
          }
        }

        .apply-nums {
          margin-top: 40px;
          font-size: 24px;
          .appply-imgs {
            margin-right: 28px;
            & > li {
              width: 44px;
              height: 44px;
              border: 2px solid #fff;

              &:not(:first-child) {
                margin-left: -8px;
              }
            }
          }
        }

        .download-tip {
          margin-top: 30px;
          font-size: 28px;
        }
      }
      .lessonResultContent {
        .resultImg {
          width: 196px;
          // margin-top:80px;
        }
        .context {
          font-size: 40px;
          margin-top: 40px;
          margin-bottom: 10px;
        }
        .subtitle {
          width: 528px;
          color: #696464;
          margin-top: 32px;
        }
        span {
          font-size: 30px;
        }
      }
      .footerBorder {
        height: 80px;
        margin-top: -1px;
      }
    }
    .signUpByPhone {
      // height:1200px;
    }
    .introduction {
      width: 680px;
      margin-top: 60px;
      .title {
        width: 556px;
        height: 38px;
        .bgtext {
          font-size: 80px;
          top: -16px;
        }
        .titleText {
          font-size: 56px;
          top: -22px;
        }
      }
      .whiteBoard {
        border-radius: 16px;
        padding: 46px 36px;
        box-shadow: 0px 30px 30px 0px rgba(0, 0, 0, 0.1);
        margin-top: 80px;
        font-size: 24px;
        img {
          max-width: 100% !important;
        }
      }
    }
  }
  .submitBtn {
    font-size: 32px;
    width: 540px;
    height: 80px;
    line-height: 80px;
    background: #009265;
    border-radius: 10px;
    margin-top: 100px;
  }
}
</style>
<template>
  <div v-if="ajaxReturn"
       :class="isMobile?'intermediateM':'intermediate'"
       @click="handle">
    <div class="page">
      <div class="lesson"
           :class="{signUpByPhone:usePhone}">
        <div class="lessonInfo">
          <p class="comma" @click="showDownloadImg"></p>
          <p class="lessonName text-2-lines">{{lessonInfo.lessonName?lessonInfo.lessonName:'-'}}</p>
          <p class="teacherName text-1-line">{{$t('publesson.teacher')}}{{lessonInfo.teacherName}}</p>
          <div class="avatarImg">
            <img :src="lessonInfo.courseLogo|serverimg_url('', 'avatar')"
                 :onerror="errorImg"
                 class="avatar">
          </div>
        </div>
        <!-- 报名 -->
        <div v-if="lessonInfo.signUpStatus===''"
             class="lessonContent"
             :style="{paddingTop:isMobile?'84px':'44px'}">
          <!-- 手机号报名 -->
          <signUpByPhone v-if="usePhone"
                         ref="signUpByPhone"
                         @signUp="signUp"
                         @routerTo="routerTo"
                         :config="signUpByPhoneConfig">
          </signUpByPhone>
          <div v-else>
            <div class="lessonTime">
              <div class="lesson-start-time">
                <template  v-if="lessonInfo.lessonStartTime">
                  <p class="lesson-hm">{{ handlerTime(lessonInfo.lessonStartTime).hm }}</p>
                  <p class="lesson-year">{{ handlerTime(lessonInfo.lessonStartTime).yearDate }}</p>
                </template>
                <span v-else>--</span>
              </div>

              <div class="lesson-duration">
                {{lessonInfo.druation | moment_format('mm','durationHumanize')}}{{$t('publesson.minute')}}
              </div>

              <div class="lesson-end-time">
                <template  v-if="lessonInfo.lessonEndtTime">
                  <p class="lesson-hm">{{ handlerTime(lessonInfo.lessonEndtTime).hm }}</p>
                  <p class="lesson-year">{{ handlerTime(lessonInfo.lessonEndtTime).yearDate }}</p>
                </template>
                <span v-else>--</span>
              </div>
            </div>
            <p class="copy">
              <span>{{ $t('publesson.publessonId') }}</span>
              <span class="publessonId">{{publessonId}}</span>
              <span class="copy-icon btn_copy_text" :data-clipboard-text="publessonId"></span>
            </p>
            <div class="submitBtn primary"
                 @click="signUpNow">{{$t('publesson.applyNow')}}</div>
          </div>
          <template v-if="!usePhone">
            <!-- 支持下载的浏览器 -->
            <p v-if="isSupport" data-id="classInDownLoad_auto" class="download-tip">
              <span v-html="$t('publesson.downLoadTip')"></span>
            </p>
            <!-- 不支持下载的浏览器 -->
            <p v-else class="download-tip" @click="download">
              <span v-html="$t('publesson.downLoadTip')"></span>
            </p>
          </template>
          <!-- <p v-if="!usePhone" data-id="classInDownLoad_auto" class="download-tip">
            <span v-html="$t('publesson.downLoadTip')"></span>
          </p> -->
          <div v-if="lessonInfo.classStudentNum > 0 && !usePhone" class="apply-nums">
            <ul class="appply-imgs eeo-ul">
              <template v-for="(item, index) in lessonInfo.studentList">
                <li v-if="index < 6" :key="index" class="apply-item">
                  <img 
                    :src="item.url|serverimg_url('', 'avatar')"
                    :onerror="errorImg"
                    class="avatar"
                  >
                </li>
              </template>
            </ul>
            <span class="apply-num">
              {{ lessonInfo.classStudentNum > 6 ? $t('publesson.tip.isAppliedMax', {num: lessonInfo.classStudentNum}) : $t('publesson.tip.isApplied', {num: lessonInfo.classStudentNum}) }}</span>
          </div>
          <!-- <dot></dot> -->
        </div>
        <div v-if="lessonInfo.signUpStatus==='jumpPage'"
             class="lessonContent jumpPage">
          <jumppage :jumpInfo="jumpInfo"></jumppage>
          <!-- <dot></dot> -->
        </div>
        <!-- 课程结束 -->
        <div v-show="lessonInfo.signUpStatus==='lessonEnd'"
             class="lessonContent lessonResultContent">
          <img class="resultImg"
               src="@/assets/images/k/tip_end.png">
          <p class="context">{{$t('publesson.end')}}</p>
          <p class="subtitle"
             v-html="$t('publesson.subtitle.downAndReady')"></p>
          <!-- 支持下载的浏览器 -->
          <div data-id="classInDownLoad_auto"
            v-if="isSupport" 
            class="submitBtn primary">{{$t('publesson.down')}}</div>
          <!-- 不支持下载的浏览器 -->
          <div v-else class="submitBtn primary" @click="download">{{$t('publesson.down')}}</div>
          <!-- <dot></dot> -->
        </div>
        <!-- 报名满 -->
        <div v-show="lessonInfo.signUpStatus==='lessonStuFull'"
             class="lessonContent lessonResultContent">
          <img src="@/assets/images/k/tip_end.png"
               class="resultImg lessonEnd">
          <p class="context">{{$t('publesson.full')}}</p>
          <p class="subtitle"
             v-html="$t('publesson.subtitle.downAndReady')"></p>
          <!-- 支持下载的浏览器 -->
          <div data-id="classInDownLoad_auto"
            v-if="isSupport" 
            class="submitBtn primary">{{$t('publesson.down')}}</div>
          <!-- 不支持下载的浏览器 -->
          <div v-else class="submitBtn primary" @click="download">{{$t('publesson.down')}}</div>
          <!-- <dot></dot> -->
        </div>
        <!-- 报名成功 -->
        <div v-show="lessonInfo.signUpStatus==='signUpSuccess'"
             class="lessonContent lessonResultContent signUpSuccess">
          <img src="@/assets/images/k/tip_success.png"
               class="resultImg lessonEnd">
          <p class="context"
             style="color:#333;">{{$t('publesson.success')}}</p>
          <p class="subtitle"
             v-html="$t('publesson.subtitle.downAndinstall')"></p>
          <!-- 支持下载的浏览器 -->
          <div data-id="classInDownLoad_auto"
            v-if="isSupport" 
            class="submitBtn primary">{{$t('publesson.down')}}</div>
          <!-- 不支持下载的浏览器 -->
          <div v-else class="submitBtn primary" @click="download">{{$t('publesson.down')}}</div>
          <!-- <div v-if="lessonInfo.signUpStatus==='signUpSuccess'"
          class="lessonContent lessonResultContent subtitle">
          <img src="@/assets/images/k/tip_success.png" class="resultImg lessonEnd">
          <p class="context" style="color:#009265;">{{$t('publesson.success')}}</p>
          <p class="subtitle" v-html="$t('publesson.subtitle.downAndinstall')"></p>
          <a class="submitBtn primary" target="_blank" :href="deviceTypeUrl">{{$t('publesson.down')}}</a> -->
          <!-- <dot></dot> -->
        </div>
        <!-- <div class="footerBorder"></div> -->
      </div>
      <!-- 机构简介 -->
      <div class="introduction"
           v-if="(lessonInfo.signUpStatus===''||lessonInfo.signUpStatus==='signUpSuccess')&&lessonInfo.schoolIntroduction">
        <p class="title">
          <span class="bgtext">introduction</span>
          <span class="titleText">{{$t('publesson.institution')}}</span>
        </p>
        <div class="whiteBoard"
             v-html="lessonInfo.schoolIntroduction">
        </div>
      </div>
      <van-loading v-if="$root.loading"
                   class="loading"
                   :size="isMobile ? 80 : 40" />
    </div>
    <MaskBox
      v-if="showMask"
      :lessonInfo="lessonInfo"
      :publessonId="publessonId"
      @hide-mask="hideDownloadImg"
    />
  </div>
</template>

<script>
import qs from 'qs';
import url from 'url';
import moment from 'moment';
import moment_format from '@/filters/moment_format';
import serverimg_url from '@/filters/serverimg_url';
import html_text_mobile from '@/filters/html_text_mobile';
import strCopy from '@/api/strcopy';
import signUpByPhone from '@/components/publesson/signup_byphone.vue';
// import dot from '@/components/publesson/content_dot.vue';
import jumppage from '@/components/publesson/jumppage.vue';
import restful_publesson from '@/api/publesson/restful_publesson.js';
import ClipboardJS from 'clipboard'
import MaskBox from '@/components/publesson/DownloadImg.vue'

export default {
  components: {
    signUpByPhone,
    jumppage,
    MaskBox,
    // dot
  },
  filters: {
    serverimg_url,
    moment_format,
    html_text_mobile
  },
  data () {
    return {
      isMobile: window.browserVersion.mobile,
      lessonKey: url.parse(window.location.href, true).query.lessonKey,
      publessonId: url.parse(window.location.href, true).query.classSN ||
        url.parse(window.location.href, true).query.sn,
      formatStr: this.$root.globalData.localeLangType == 'en' ? 'MMMM Do,YYYY HH:mm' : 'M月D日 HH:mm',
      clientName: '',
      showMask: false,
      lessonInfo: {
        lessonId: '',
        courseLogo: '',
        lessonName: '',
        lessonStartTime: '',
        teacherLogo: '',
        teacherName: '',
        druation: '',
        schoolIntroduction: '',
        signUpStatus: '',
        classStudentNum: 0,
        studentList: [],
      },
      usePhone: url.parse(window.location.href, true).query.usePhone,
      signUpByPhoneConfig: {
        lessonId: '',
      },
      deviceTypeUrl: '',
      inWeixin: false,
      errorNo: '',
      canClick: true,
      ajaxReturn: false,
      errorImg: 'this.src="' + require('@/assets/images/k/avatar_defalut.png') + '"',
    }
  },
  watch: {
  },
  computed: {
    jumpInfo () {
      var obj = {
        publessonId: this.publessonId
      };
      return obj
    },
    isSupport() {
      let result = true
      let android = window.browserVersion.weixin && window.browserVersion.mobile && window.browserVersion.android
      let ios = (window.browserVersion.weixin && !this.isSupportIosVersion()) || 
                (window.browserVersion.mobile && window.browserVersion.ios && !(window.browserVersion.safari || window.browserVersion.weixin))
      result = android || ios
      return !result
    },
  },
  methods: {
    strCopy: strCopy,
    routerTo (pageName) {
      this.$emit('routerTo', 'tippage');
    },
    handle () {
      if (this.$refs.signUpByPhone && this.$refs.signUpByPhone.optionList) {
        this.$refs.signUpByPhone.closeOptionList();
      }
    },
    changeMeta (shareDataConfig) {
      document.title = shareDataConfig.title;

      var metaName = document.createElement("meta");
      metaName.setAttribute('itemprop', 'name');
      metaName.content = shareDataConfig.title;
      document.head.appendChild(metaName);

      var metaImg = document.createElement("meta");
      metaImg.name = "image";
      metaImg.setAttribute('itemprop', 'image');
      metaImg.content = shareDataConfig.imgUrl;
      document.head.appendChild(metaImg);

      var metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      metaDesc.setAttribute('itemprop', 'description');
      metaDesc.content = shareDataConfig.desc;
      document.head.appendChild(metaDesc);
    },
    getShareData (resData) {
      var shareDataConfig = {
        title: this.$t('publesson.share.title1', {
          lessonName: resData.lessonInfoData.lessonName,
          schoolName: resData.lessonInfoData.schoolName
        }),
        desc: this.$t('publesson.share.des', {
          teacher: resData.lessonInfoData.teacherName,
          time: moment_format(resData.lessonInfoData.lessonStartTime, this.formatStr),
          schoolName: resData.lessonInfoData.schoolName
        }),
        title2: this.$t('publesson.share.title2', {
          lessonName: resData.lessonInfoData.lessonName,
          time: moment_format(resData.lessonInfoData.lessonStartTime, this.formatStr),
          schoolName: resData.lessonInfoData.schoolName
        }),
        imgUrl: resData.lessonInfoData.courseLogo ? (window.location.protocol + '//'
          + window.EEOENV.upload.ugcfile + '/' + resData.lessonInfoData.courseLogo) :
          'https://static.eeo.cn/assets/images/weixin-share.png',
        link: window.location.href.replace(window.location.host, window.EEOENV.share.main),
      }
      document.title = shareDataConfig.title;
      if (this.isMobile) {
        this.changeMeta(shareDataConfig);
      }
      window.eeoWxShare(shareDataConfig);
    },
    handlerTime(time) { // 处理时间
      const lessonTime = moment_format(time, 'YYYY/MM/DD*HH:mm').split('*')
      let hm = lessonTime[1] || '--'
      let yearDate = lessonTime[0] || '--'
      return {
        hm,
        yearDate
      }
    },
    handlerCopy() {
      const clip = new ClipboardJS('.btn_copy_text');
      const tipClass = this.isMobile ? 'copy-success-tipM' : 'copy-success-tip'
      const copySuccess = this.$t('publesson.tip.copySuccess')
      clip.on('success', function () {
        vant.Toast({
          message: copySuccess,
          className: tipClass,
          // duration: 0,
        });
      });
    },
    showDownloadImg() {
      this.showMask = true
      document.body.style = `
        height: 100%;
        overflow: hidden;
      `
    },
    hideDownloadImg() {
      this.showMask = false
      document.body.style = `
        height: auto;
        overflow: auto;
      `
    },
    download() {
      if (!window.eeoRunWithoutWx()) {
        return;
      }
    },
    getPublessonInfo () {
      this.$root.loading = true;
      restful_publesson('getLessonInfo', {
        lessonKey: this.lessonKey,
        classSN: this.publessonId
      }).then((res) => {
        this.$root.loading = false;
        var resData = res.data;
        this.ajaxReturn = true;
        if (resData) {
          if (typeof resData == 'number') {
            this.errorNo = resData;
            switch (resData) {
              case 304:
                window.meaasgeAlert(this.$t('publesson.tip.institutionDisabled'));
                break;
              case 104:
                this.$emit('routerTo', 'tippage', this.$t('publesson.tip.invalid'));
                break;
              case 212:
                this.$emit('routerTo', 'tippage', this.$t('publesson.tip.deleted'));
                break;

            }
          } else {
            this.lessonInfo = resData.lessonInfoData;
            this.lessonInfo.schoolIntroduction = html_text_mobile(resData.lessonInfoData.schoolIntroduction);
            // this.lessonInfo.signUpStatus='lessonEnd'
            this.signUpByPhoneConfig.lessonId = resData.lessonInfoData.lessonId;
            this.getShareData(resData);
            this.handlerTime(this.lessonInfo.lessonStartTime)
            // // test数据设置
            // this.lessonInfo.applyers = [1,2,3,4,5,6,7,8]
          }
        }
      })
    },
    signUp (status) {
      this.lessonInfo.signUpStatus = status;
    },
    signUpNow () {
      if (this.lessonInfo.lessonName) {
        var url = "classin://www.eeo.cn/enterclass?openClassId=" + this.publessonId;
        if (window.browserVersion.mobile) {
          this.browserMobile(url);
        } else {
          this.browserPc(url)
        }
      } else {
        this.isHaslessonName();
      }
    },
    browserMobile (url) {
      if (!eeoRunWithoutWx()) {
        return;
      }
      if (window.browserVersion.android) {
        window.location.href = url;
        this.$root.loading = true;
        setTimeout(() => {
          this.$root.loading = false;
          window.location.href = window.location.href + "&usePhone=true";
        }, 3000);
      }
      if (window.browserVersion.ios) {
        var newUrl = window.location.href.replace('//share', '//static') + "&usePhone=true";
        setTimeout(() => {
          window.location.href = newUrl;
        }, 200);
      }
    },
    browserPc (url) {
      this.lessonInfo.signUpStatus = 'jumpPage';
      var callBack = () => {
        if (window.browserVersion.chrome) {
          window.location = url
        } else {
          var iframe = document.createElement("iframe");
          iframe.src = url;
          // iframe.style.width ="0";
          // iframe.style.height="0";
          iframe.style.display = "none";
          document.body.appendChild(iframe);
          this.$nextTick(() => {
            iframe.parentNode.removeChild(iframe);
          })
        }
      }
      eeoRunWithoutWx(callBack);
      // window.location.href = window.location.href+"&usePhone=true";
    },
    isHaslessonName () {
      if (this.canClick) {
        switch (this.errorNo) {
          case 304:
            window.meaasgeAlert(this.$t('publesson.tip.institutionDisabled'));
            this.canClick = false;
            setTimeout(() => {
              this.canClick = true;
            }, 1000)
            break;
        }
      }
    },
    getDevice () {
      var isiOS = window.browserVersion.ios;
      var isAndroid = window.browserVersion.android;
      if (isiOS) {
        this.deviceTypeUrl = 'https://itunes.apple.com/app/id1226361488?mt=8'
      } else if (isAndroid) {
        this.deviceTypeUrl = 'https://android.myapp.com/myapp/detail.htm?apkName=cn.eeo.classin&ADTAG=mobile'
      } else {
        this.deviceTypeUrl = 'https://www.eeo.cn/cn/download.html'
      }
    },
    isSupportIosVersion() {
			if (!window.browserVersion.ios) {
				return false;
			}
			var ver = window.navigator.userAgent.toLowerCase().match(/os (.*?) like mac os/);
			if (!ver) {
				return true
			}
			var minVer = '9';
			var minVerArr = minVer.split('_');
			var currentVerArr = ver[1].split('_');
			var verLen = currentVerArr.length;
			while (minVerArr.length < verLen) {
				minVerArr.push('0')
			}
			var isSupport = false;
			// var i = 0;
			var compare = function (minVer, currentVer) {
				if (minVer < currentVer) {
					isSupport = true;
				} else if (minVer > currentVer) {
					isSupport = false;
				}
			}
			for (let i = 0; i < verLen; i++) {
				if (minVerArr[i] * 1 == currentVerArr[i] * 1) {
					if (i == verLen - 1) {
						isSupport = true;
					} else {
						compare(minVerArr[i] * 1, currentVerArr[i] * 1);
					}
				} else {
					compare(minVerArr[i] * 1, currentVerArr[i] * 1)
					return isSupport
				}
			}
			return isSupport
		},
  },

  mounted () {
    this.getPublessonInfo();
    this.getDevice();
    this.clientName = this.$root.clientName;
    this.inWeixin = window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger';
    if (this.usePhone) {
      if (this.lessonKey) {
        var backUrl = window.location.origin + window.location.pathname + '?lessonKey=' + this.lessonKey + '&classSN=' + this.publessonId;
      } else {
        var backUrl = window.location.origin + window.location.pathname + '?sn=' + this.publessonId;
      }
      eeoRunWithoutWx(false, window.location.href);
    }
    this.handlerCopy();
  }
}
</script>